import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { selectNavItem } from '../actions';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Hidden from '@material-ui/core/Hidden';
import { featuresList } from '../constants';

const useStyles = makeStyles((theme) => ({
    drawerPaper: {
        width: (styleProps) => styleProps.drawerWidth,
        flexShrink: 0,
        zIndex: theme.zIndex.appBar - 1,
    },
    drawer: {
        width: (styleProps) => styleProps.drawerWidth,
    },
    toolbar: theme.mixins.toolbar,
    drawerItem: {
        color: theme.palette.secondary.main,
    },
    drawerItemSelected: {
        color: theme.palette.primary.main,
    },
    list: {
        margin: 16,
        padding: 0,
    },
    listItem: {
        borderRadius: 4,
    },
    listItemIcon: {
        minWidth: 20,
        minHeight: 20,
        marginRight: 8,
    },
}));

export default function NavBar({ drawer, hideDrawer, featureFlags, userProfile }) {
    const styleProps = {
        drawerWidth: 260,
    };

    const classes = useStyles(styleProps);

    const dispatch = useDispatch();

    const activeNavItem = useSelector(({ navDrawer }) => navDrawer.activeNavItem);

    const handleChangeNavItem = (navItem) => {
        hideDrawer();
        dispatch(selectNavItem(navItem));
    };

    const checkRoles = (item) => !item.roles?.length || userProfile?.roles?.some(role => item.roles.includes(role));

    const checkFeatures = (item) => {
        if (item.experimental) {
            return featureFlags?.includes('Experimental');
        } else {
            return featureFlags?.includes(item.name) || !featureFlags?.filter(flag => flag !== 'Experimental').length;
        }
    };

    const navDrawerItems = (
        <List className={classes.list}>
            {featuresList.navDrawer.navItems.filter(item => (checkFeatures(item)) && checkRoles(item)).map((item) => (
                <ListItem
                    key={item.key}
                    button
                    className={classes.listItem}
                    selected={activeNavItem === item.key}
                    onClick={() => handleChangeNavItem(item.key)}
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <item.icon color={activeNavItem === item.key ? 'primary' : 'inherit'} />
                    </ListItemIcon>
                    <ListItemText
                        className={activeNavItem === item.key ? classes.drawerItemSelected : classes.drawerItem}
                        primary={item.name}
                    />
                </ListItem>
            ))}
        </List>
    );

    return (
        <React.Fragment>
            <Hidden smDown>
                <Drawer
                    className={classes.drawer}
                    variant="permanent"
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >
                    <div className={classes.toolbar} />
                    {navDrawerItems}
                </Drawer>
            </Hidden>
            <Hidden mdUp>
                <Drawer
                    className={classes.drawer}
                    open={drawer}
                    onClose={hideDrawer}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >
                    {navDrawerItems}
                </Drawer>
            </Hidden>
        </React.Fragment>
    );
}
